
module.exports = function ExpiryInputWidget (host, config) {

  // Dom
  var $mode   = $('[data-mode-selector]', host);
  var $date   = $('[data-date-input]',    host);
  var $period = $('[data-period-input]',  host);

  // Functions
  function updateVisibility (allowFocus) {
    allowFocus = !!allowFocus;

    if ($mode.val() === 'period') {
      $date.hide();
      if (allowFocus) $period.show().find('input').eq(0).focus();
    } else {
      $period.hide();
      if (allowFocus) $date.show().find('select').eq(0).focus();
    }
  }

  // Listeners
  $mode.on('change', updateVisibility);

  // Init
  updateVisibility(false);

};

